/**
 * Generated by `npm run legal:sync`. Do not edit by hand.
 * Static JSON chunks only — never Cloud Run / main API.
 */
import type { LegalCountryAddendaFile } from "@/content/legal-country-overlay";

export const LEGAL_ADDENDA_LOADERS: Record<
  string,
  () => Promise<{ default: LegalCountryAddendaFile }>
> = {
  AE: () => import("./legal-policies.cache/addenda/AE.json"),
  AT: () => import("./legal-policies.cache/addenda/AT.json"),
  AU: () => import("./legal-policies.cache/addenda/AU.json"),
  BD: () => import("./legal-policies.cache/addenda/BD.json"),
  BE: () => import("./legal-policies.cache/addenda/BE.json"),
  BG: () => import("./legal-policies.cache/addenda/BG.json"),
  BR: () => import("./legal-policies.cache/addenda/BR.json"),
  CA: () => import("./legal-policies.cache/addenda/CA.json"),
  CH: () => import("./legal-policies.cache/addenda/CH.json"),
  CN: () => import("./legal-policies.cache/addenda/CN.json"),
  CY: () => import("./legal-policies.cache/addenda/CY.json"),
  CZ: () => import("./legal-policies.cache/addenda/CZ.json"),
  DE: () => import("./legal-policies.cache/addenda/DE.json"),
  DK: () => import("./legal-policies.cache/addenda/DK.json"),
  EE: () => import("./legal-policies.cache/addenda/EE.json"),
  FI: () => import("./legal-policies.cache/addenda/FI.json"),
  FR: () => import("./legal-policies.cache/addenda/FR.json"),
  GB: () => import("./legal-policies.cache/addenda/GB.json"),
  GR: () => import("./legal-policies.cache/addenda/GR.json"),
  HR: () => import("./legal-policies.cache/addenda/HR.json"),
  HU: () => import("./legal-policies.cache/addenda/HU.json"),
  ID: () => import("./legal-policies.cache/addenda/ID.json"),
  IE: () => import("./legal-policies.cache/addenda/IE.json"),
  IL: () => import("./legal-policies.cache/addenda/IL.json"),
  IN: () => import("./legal-policies.cache/addenda/IN.json"),
  IT: () => import("./legal-policies.cache/addenda/IT.json"),
  JP: () => import("./legal-policies.cache/addenda/JP.json"),
  KR: () => import("./legal-policies.cache/addenda/KR.json"),
  LT: () => import("./legal-policies.cache/addenda/LT.json"),
  LU: () => import("./legal-policies.cache/addenda/LU.json"),
  LV: () => import("./legal-policies.cache/addenda/LV.json"),
  MT: () => import("./legal-policies.cache/addenda/MT.json"),
  MX: () => import("./legal-policies.cache/addenda/MX.json"),
  MY: () => import("./legal-policies.cache/addenda/MY.json"),
  NL: () => import("./legal-policies.cache/addenda/NL.json"),
  NO: () => import("./legal-policies.cache/addenda/NO.json"),
  PL: () => import("./legal-policies.cache/addenda/PL.json"),
  PT: () => import("./legal-policies.cache/addenda/PT.json"),
  RO: () => import("./legal-policies.cache/addenda/RO.json"),
  RU: () => import("./legal-policies.cache/addenda/RU.json"),
  SA: () => import("./legal-policies.cache/addenda/SA.json"),
  SE: () => import("./legal-policies.cache/addenda/SE.json"),
  SI: () => import("./legal-policies.cache/addenda/SI.json"),
  SK: () => import("./legal-policies.cache/addenda/SK.json"),
  TH: () => import("./legal-policies.cache/addenda/TH.json"),
  TR: () => import("./legal-policies.cache/addenda/TR.json"),
  TW: () => import("./legal-policies.cache/addenda/TW.json"),
  UA: () => import("./legal-policies.cache/addenda/UA.json"),
  US: () => import("./legal-policies.cache/addenda/US.json"),
  VN: () => import("./legal-policies.cache/addenda/VN.json"),
};
